import validator from "validator";
import { CreateCompanyPayload } from "../../types/company/company-payload";

export const validateCompanyPayload = (
  createCompanyPayload: CreateCompanyPayload
) => {
  const name = validator.isEmpty(createCompanyPayload.name);
  const phone =
    !validator.isNumeric(createCompanyPayload.phone) ||
    !validator.isLength(createCompanyPayload.phone, {
      min: 11,
      max: 11,
    });
  return {
    hasError: name || phone,
    validationResults: {
      name,
      phone,
    },
  };
};
